[
  {
    "name": "Mariana Domínguez",
    "birthdate": "15/11/2003",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/591004252.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "right",
    "height": 160,
    "draftJersey": 11,
    "macros": {
      "physical": 64,
      "duels": 64,
      "shooting": 70,
      "defence": 84,
      "passing": 70,
      "skills": 52,
      "average": 71
    },
    "matchYtVideoId": "ZZECfp6AmWY",
    "profileYtVideoId": "OpKYJXoSZ3c"
  },
  {
    "name": "Lucero Zavala",
    "birthdate": "16/05/1999",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/584271573.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "right",
    "height": 163,
    "draftJersey": 12,
    "macros": {
      "physical": 70,
      "duels": 74,
      "shooting": 69,
      "defence": 79,
      "passing": 87,
      "skills": 61,
      "average": 75
    },
    "matchYtVideoId": "ZZECfp6AmWY",
    "profileYtVideoId": "JvcdQUNvX3w"
  },
  {
    "name": "Cristina Fonseca",
    "birthdate": "25/02/1993",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/585349666.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "left",
    "height": 167,
    "draftJersey": 13,
    "macros": {
      "physical": 78,
      "duels": 66,
      "shooting": 72,
      "defence": 92,
      "passing": 76,
      "skills": 88,
      "average": 78
    },
    "matchYtVideoId": "ZZECfp6AmWY",
    "profileYtVideoId": "tOZD9GEHBqY"
  },
  {
    "name": "Salma Mendoza",
    "birthdate": "20/09/2000",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/665518421.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 165,
    "draftJersey": 14,
    "macros": {
      "physical": 71,
      "duels": 75,
      "shooting": 65,
      "defence": 83,
      "passing": 73,
      "skills": 53,
      "average": 70
    },
    "matchYtVideoId": "ZZECfp6AmWY",
    "profileYtVideoId": "liKDXKsHWRM"
  },
  {
    "name": "Nancy Escobar",
    "birthdate": "16/11/1994",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/598566429.png",
    "country": "Mexico",
    "role": "DL",
    "foot": "right",
    "height": 150,
    "draftJersey": 15,
    "macros": {
      "physical": 88,
      "duels": 70,
      "shooting": 73,
      "defence": 84,
      "passing": 79,
      "skills": 53,
      "average": 73
    },
    "matchYtVideoId": "ZZECfp6AmWY",
    "profileYtVideoId": "Ta_WM6f_wEc"
  },
  {
    "name": "Yulissa Acevedo",
    "birthdate": "12/07/1999",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/191556977.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "right",
    "height": 158,
    "draftJersey": 17,
    "macros": {
      "physical": 69,
      "duels": 66,
      "shooting": 74,
      "defence": 92,
      "passing": 84,
      "skills": 89,
      "average": 81
    },
    "matchYtVideoId": "ZZECfp6AmWY",
    "profileYtVideoId": "iUKXguHFBHA"
  },
  {
    "name": "Verónica Jiménez",
    "birthdate": "27/02/1999",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/360113181.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "right",
    "height": 168,
    "draftJersey": 18,
    "macros": {
      "physical": 83,
      "duels": 70,
      "shooting": 76,
      "defence": 88,
      "passing": 83,
      "skills": 70,
      "average": 81
    },
    "matchYtVideoId": "ZZECfp6AmWY",
    "profileYtVideoId": "AFHer6agADg"
  },
  {
    "name": "Nancy Trujillo",
    "birthdate": "05/06/2003",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/1696058.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 164,
    "draftJersey": 19,
    "macros": {
      "physical": 66,
      "duels": 66,
      "shooting": 69,
      "defence": 77,
      "passing": 87,
      "skills": 52,
      "average": 70
    },
    "matchYtVideoId": "ZZECfp6AmWY",
    "profileYtVideoId": "OktPU8XccVg"
  },
  {
    "name": "Cecilia Paredes",
    "birthdate": "19/04/2001",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/511513739.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 156,
    "draftJersey": 20,
    "macros": {
      "physical": 65,
      "duels": 61,
      "shooting": 52,
      "defence": 73,
      "passing": 68,
      "skills": 52,
      "average": 62
    },
    "matchYtVideoId": "ZZECfp6AmWY",
    "profileYtVideoId": "71qLwzNbDiY"
  },
  {
    "name": "Fernanda Figueroa",
    "birthdate": "12/06/2003",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/111132082.png",
    "country": "Mexico",
    "role": "DL",
    "foot": "right",
    "height": 160,
    "draftJersey": 21,
    "macros": {
      "physical": 79,
      "duels": 70,
      "shooting": 68,
      "defence": 79,
      "passing": 83,
      "skills": 89,
      "average": 76
    },
    "matchYtVideoId": "ZZECfp6AmWY",
    "profileYtVideoId": "UhDX_F3SIGI"
  },
  {
    "name": "Julieta Padilla",
    "birthdate": "06/06/1995",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/738939851.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "right",
    "height": 156,
    "draftJersey": 23,
    "macros": {
      "physical": 67,
      "duels": 84,
      "shooting": 65,
      "defence": 68,
      "passing": 88,
      "skills": 79,
      "average": 73
    },
    "matchYtVideoId": "F_bjbMAGMz8",
    "profileYtVideoId": "ni28ctBTGgE"
  },
  {
    "name": "Michelle Jardón",
    "birthdate": "19/07/1994",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/536383328.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "right",
    "height": 160,
    "draftJersey": 24,
    "macros": {
      "physical": 72,
      "duels": 79,
      "shooting": 64,
      "defence": 79,
      "passing": 74,
      "skills": 70,
      "average": 74
    },
    "matchYtVideoId": "F_bjbMAGMz8",
    "profileYtVideoId": "LYEYGqaTtTs"
  },
  {
    "name": "Fernanda González",
    "birthdate": "14/02/2003",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/266546082.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "left",
    "height": 166,
    "draftJersey": 25,
    "macros": {
      "physical": 73,
      "duels": 70,
      "shooting": 73,
      "defence": 83,
      "passing": 82,
      "skills": 80,
      "average": 77
    },
    "matchYtVideoId": "F_bjbMAGMz8",
    "profileYtVideoId": "AoJZSmnjQUY"
  },
  {
    "name": "Erika Engwall",
    "birthdate": "20/11/1999",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/518970646.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "left",
    "height": 157,
    "draftJersey": 26,
    "macros": {
      "physical": 64,
      "duels": 70,
      "shooting": 64,
      "defence": 70,
      "passing": 69,
      "skills": 79,
      "average": 69
    },
    "matchYtVideoId": "F_bjbMAGMz8",
    "profileYtVideoId": "vS_EQWknsIU"
  },
  {
    "name": "Camila Rodriguez",
    "birthdate": "19/04/1998",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/600318495.png",
    "country": "Mexico",
    "role": "DL",
    "foot": "right",
    "height": 168,
    "draftJersey": 27,
    "macros": {
      "physical": 80,
      "duels": 75,
      "shooting": 66,
      "defence": 83,
      "passing": 92,
      "skills": 88,
      "average": 78
    },
    "matchYtVideoId": "F_bjbMAGMz8",
    "profileYtVideoId": "uk1Kvx2rl_w"
  },
  {
    "name": "Yuliana Mora",
    "birthdate": "23/02/2000",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/393310791.png",
    "country": "Mexico",
    "role": "DL",
    "foot": "right",
    "height": 162,
    "draftJersey": 28,
    "macros": {
      "physical": 80,
      "duels": 75,
      "shooting": 72,
      "defence": 84,
      "passing": 75,
      "skills": 71,
      "average": 75
    },
    "matchYtVideoId": "F_bjbMAGMz8",
    "profileYtVideoId": "K1mjSdmF4kE"
  },
  {
    "name": "Ximena Millán",
    "birthdate": "27/03/2002",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/255851414.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "left",
    "height": 162,
    "draftJersey": 29,
    "macros": {
      "physical": 71,
      "duels": 65,
      "shooting": 74,
      "defence": 83,
      "passing": 79,
      "skills": 61,
      "average": 75
    },
    "matchYtVideoId": "F_bjbMAGMz8",
    "profileYtVideoId": "LGNyYdPksvc"
  },
  {
    "name": "Montserrat Sánchez",
    "birthdate": "21/10/1999",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/545596195.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 162,
    "draftJersey": 31,
    "macros": {
      "physical": 77,
      "duels": 70,
      "shooting": 80,
      "defence": 78,
      "passing": 78,
      "skills": 79,
      "average": 77
    },
    "matchYtVideoId": "F_bjbMAGMz8",
    "profileYtVideoId": "uLREDzsxfX8"
  },
  {
    "name": "Rocío Sainz",
    "birthdate": "26/04/1985",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/871988022.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 160,
    "draftJersey": 32,
    "macros": {
      "physical": 71,
      "duels": 88,
      "shooting": 83,
      "defence": 92,
      "passing": 78,
      "skills": 71,
      "average": 81
    },
    "matchYtVideoId": "F_bjbMAGMz8",
    "profileYtVideoId": "I1la7dOkrNQ"
  },
  {
    "name": "Daniela Perez",
    "birthdate": "03/10/2003",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/658561131.png",
    "country": "Mexico",
    "role": "DL",
    "foot": "right",
    "height": 155,
    "draftJersey": 33,
    "macros": {
      "physical": 79,
      "duels": 84,
      "shooting": 74,
      "defence": 84,
      "passing": 87,
      "skills": 88,
      "average": 81
    },
    "matchYtVideoId": "F_bjbMAGMz8",
    "profileYtVideoId": "DgO9gqPNcAU"
  },
  {
    "name": "Naomi Valenzuela",
    "birthdate": "13/07/2002",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/978789682.png",
    "country": "Mexico",
    "role": "DL",
    "foot": "right",
    "height": 158,
    "draftJersey": 34,
    "macros": {
      "physical": 82,
      "duels": 93,
      "shooting": 84,
      "defence": 78,
      "passing": 93,
      "skills": 89,
      "average": 87
    },
    "matchYtVideoId": "F_bjbMAGMz8",
    "profileYtVideoId": "MmqkqWBohhw"
  },
  {
    "name": "María Enríquez",
    "birthdate": "12/01/2001",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/177556363.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "right",
    "height": 167,
    "draftJersey": 36,
    "macros": {
      "physical": 80,
      "duels": 74,
      "shooting": 73,
      "defence": 69,
      "passing": 87,
      "skills": 60,
      "average": 74
    },
    "matchYtVideoId": "fYh05znrHqM",
    "profileYtVideoId": "Ozuc2037bGk"
  },
  {
    "name": "Daniela Ramírez",
    "birthdate": "14/07/2002",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/928067508.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "left",
    "height": 157,
    "draftJersey": 37,
    "macros": {
      "physical": 79,
      "duels": 79,
      "shooting": 76,
      "defence": 74,
      "passing": 83,
      "skills": 88,
      "average": 80
    },
    "matchYtVideoId": "fYh05znrHqM",
    "profileYtVideoId": "qvM7WCUHOu0"
  },
  {
    "name": "Yeltzi Payan",
    "birthdate": "09/02/1998",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/20829534.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 154,
    "draftJersey": 38,
    "macros": {
      "physical": 71,
      "duels": 65,
      "shooting": 76,
      "defence": 86,
      "passing": 84,
      "skills": 51,
      "average": 73
    },
    "matchYtVideoId": "fYh05znrHqM",
    "profileYtVideoId": "RHVus72H66M"
  },
  {
    "name": "Salma Sánchez",
    "birthdate": "08/09/2000",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/1345097.png",
    "country": "Mexico",
    "role": "DL",
    "foot": "right",
    "height": 153,
    "draftJersey": 39,
    "macros": {
      "physical": 74,
      "duels": 70,
      "shooting": 63,
      "defence": 75,
      "passing": 60,
      "skills": 61,
      "average": 66
    },
    "matchYtVideoId": "fYh05znrHqM",
    "profileYtVideoId": "Gfrv9-5eTwo"
  },
  {
    "name": "Ana Palacios",
    "birthdate": "30/11/1988",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/482403638.png",
    "country": "Mexico",
    "role": "DL",
    "foot": "left",
    "height": 168,
    "draftJersey": 40,
    "macros": {
      "physical": 78,
      "duels": 79,
      "shooting": 72,
      "defence": 83,
      "passing": 81,
      "skills": 70,
      "average": 76
    },
    "matchYtVideoId": "fYh05znrHqM",
    "profileYtVideoId": "u1wxVXylA9E"
  },
  {
    "name": "Sveidy Vaca",
    "birthdate": "27/08/1992",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/692433678.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "right",
    "height": 173,
    "draftJersey": 41,
    "macros": {
      "physical": 71,
      "duels": 79,
      "shooting": 71,
      "defence": 77,
      "passing": 69,
      "skills": 87,
      "average": 75
    },
    "matchYtVideoId": "TuwUW9m_xWw",
    "profileYtVideoId": "qWSn2YiZlg0"
  },
  {
    "name": "Zamara Casamayor",
    "birthdate": "25/08/1993",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/943787336.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "right",
    "height": 167,
    "draftJersey": 42,
    "macros": {
      "physical": 68,
      "duels": 83,
      "shooting": 74,
      "defence": 87,
      "passing": 73,
      "skills": 78,
      "average": 78
    },
    "matchYtVideoId": "fYh05znrHqM",
    "profileYtVideoId": "CB0mY40Lyx8"
  },
  {
    "name": "Barbara Zavala",
    "birthdate": "09/03/2002",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/282455270.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 156,
    "draftJersey": 44,
    "macros": {
      "physical": 81,
      "duels": 84,
      "shooting": 66,
      "defence": 87,
      "passing": 78,
      "skills": 71,
      "average": 77
    },
    "matchYtVideoId": "fYh05znrHqM",
    "profileYtVideoId": "YJAtRq7xufM"
  },
  {
    "name": "Ivany Pastor",
    "birthdate": "07/11/2005",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/56888853.png",
    "country": "Mexico",
    "role": "DL",
    "foot": "right",
    "height": 161,
    "draftJersey": 46,
    "macros": {
      "physical": 63,
      "duels": 65,
      "shooting": 65,
      "defence": 83,
      "passing": 86,
      "skills": 60,
      "average": 68
    },
    "matchYtVideoId": "fYh05znrHqM",
    "profileYtVideoId": "ngJG-tyLVOU"
  },
  {
    "name": "Karla Rodríguez",
    "birthdate": "09/03/1996",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/866246047.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 154,
    "draftJersey": 47,
    "macros": {
      "physical": 75,
      "duels": 66,
      "shooting": 72,
      "defence": 88,
      "passing": 89,
      "skills": 53,
      "average": 74
    },
    "matchYtVideoId": "v_7ouMXEGF8",
    "profileYtVideoId": "q61xb2g-dgk"
  },
  {
    "name": "Abril Martínez",
    "birthdate": "14/03/1997",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/414622744.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "right",
    "height": 156,
    "draftJersey": 48,
    "macros": {
      "physical": 63,
      "duels": 70,
      "shooting": 78,
      "defence": 93,
      "passing": 83,
      "skills": 52,
      "average": 77
    },
    "matchYtVideoId": "v_7ouMXEGF8",
    "profileYtVideoId": "2gbfqZoj_8A"
  },
  {
    "name": "Grecia Pineda",
    "birthdate": "02/01/2005",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/398556862.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 154,
    "draftJersey": 49,
    "macros": {
      "physical": 74,
      "duels": 84,
      "shooting": 82,
      "defence": 97,
      "passing": 82,
      "skills": 98,
      "average": 86
    },
    "matchYtVideoId": "v_7ouMXEGF8",
    "profileYtVideoId": "o0jUhHz-yZc"
  },
  {
    "name": "Itzel Camacho",
    "birthdate": "12/08/2003",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/368780752.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 168,
    "draftJersey": 50,
    "macros": {
      "physical": 91,
      "duels": 57,
      "shooting": 77,
      "defence": 97,
      "passing": 92,
      "skills": 70,
      "average": 81
    },
    "matchYtVideoId": "v_7ouMXEGF8",
    "profileYtVideoId": "JiYO_107LLI"
  },
  {
    "name": "Andrea Sánchez",
    "birthdate": "28/08/1997",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/50732779.png",
    "country": "Mexico",
    "role": "DL",
    "foot": "right",
    "height": 168,
    "draftJersey": 52,
    "macros": {
      "physical": 80,
      "duels": 69,
      "shooting": 83,
      "defence": 83,
      "passing": 92,
      "skills": 69,
      "average": 78
    },
    "matchYtVideoId": "v_7ouMXEGF8",
    "profileYtVideoId": "hzu8lFG-gjU"
  },
  {
    "name": "Samantha Martínez",
    "birthdate": "13/02/1997",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/13268530.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 160,
    "draftJersey": 53,
    "macros": {
      "physical": 67,
      "duels": 65,
      "shooting": 71,
      "defence": 60,
      "passing": 82,
      "skills": 69,
      "average": 70
    },
    "matchYtVideoId": "v_7ouMXEGF8",
    "profileYtVideoId": "UergpIPP0MU"
  },
  {
    "name": "Katia Guzmán",
    "birthdate": "27/05/1997",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/19604174.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "right",
    "height": 163,
    "draftJersey": 54,
    "macros": {
      "physical": 70,
      "duels": 60,
      "shooting": 70,
      "defence": 84,
      "passing": 73,
      "skills": 60,
      "average": 73
    },
    "matchYtVideoId": "v_7ouMXEGF8",
    "profileYtVideoId": "32fRKGfXgVE"
  },
  {
    "name": "Brenda Arteaga",
    "birthdate": "09/07/2002",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/314271686.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 162,
    "draftJersey": 55,
    "macros": {
      "physical": 72,
      "duels": 56,
      "shooting": 63,
      "defence": 64,
      "passing": 72,
      "skills": 69,
      "average": 66
    },
    "matchYtVideoId": "v_7ouMXEGF8",
    "profileYtVideoId": "Tly6jw4aIio"
  },
  {
    "name": "Valeria Escamilla",
    "birthdate": "18/08/1999",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/165526714.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 158,
    "draftJersey": 56,
    "macros": {
      "physical": 73,
      "duels": 84,
      "shooting": 74,
      "defence": 79,
      "passing": 82,
      "skills": 80,
      "average": 79
    },
    "matchYtVideoId": "fYh05znrHqM",
    "profileYtVideoId": "pWWa8WZlGos"
  },
  {
    "name": "Karla Vargas",
    "birthdate": "30/09/1995",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/403438645.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "right",
    "height": 156,
    "draftJersey": 69,
    "macros": {
      "physical": 81,
      "duels": 61,
      "shooting": 76,
      "defence": 84,
      "passing": 87,
      "skills": 61,
      "average": 78
    },
    "matchYtVideoId": "qUGNeZtyT80",
    "profileYtVideoId": "zzusvH7wHMk"
  },
  {
    "name": "Nahomi Reyes",
    "birthdate": "23/08/2004",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/513905203.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "right",
    "height": 168,
    "draftJersey": 70,
    "macros": {
      "physical": 65,
      "duels": 65,
      "shooting": 68,
      "defence": 83,
      "passing": 70,
      "skills": 62,
      "average": 71
    },
    "matchYtVideoId": "qUGNeZtyT80",
    "profileYtVideoId": "WW0MVkbOkJs"
  },
  {
    "name": "Linda Robert",
    "birthdate": "02/10/1996",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/771272797.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 159,
    "draftJersey": 71,
    "macros": {
      "physical": 68,
      "duels": 70,
      "shooting": 66,
      "defence": 69,
      "passing": 57,
      "skills": 51,
      "average": 63
    },
    "matchYtVideoId": "qUGNeZtyT80",
    "profileYtVideoId": "3_MLOQXSsPE"
  },
  {
    "name": "María Ramírez",
    "birthdate": "05/09/1999",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/335251689.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 170,
    "draftJersey": 72,
    "macros": {
      "physical": 67,
      "duels": 60,
      "shooting": 69,
      "defence": 68,
      "passing": 69,
      "skills": 51,
      "average": 65
    },
    "matchYtVideoId": "qUGNeZtyT80",
    "profileYtVideoId": "fuUQIxU5OMI"
  },
  {
    "name": "Mariana Coxtinica",
    "birthdate": "15/05/1997",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/442208609.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 154,
    "draftJersey": 73,
    "macros": {
      "physical": 69,
      "duels": 74,
      "shooting": 72,
      "defence": 72,
      "passing": 75,
      "skills": 51,
      "average": 70
    },
    "matchYtVideoId": "qUGNeZtyT80",
    "profileYtVideoId": "C9Sm3BI_d-s"
  },
  {
    "name": "Stefanni Hernández",
    "birthdate": "01/05/1997",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/770008675.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "right",
    "height": 160,
    "draftJersey": 76,
    "macros": {
      "physical": 63,
      "duels": 73,
      "shooting": 63,
      "defence": 75,
      "passing": 60,
      "skills": 60,
      "average": 67
    },
    "matchYtVideoId": "qUGNeZtyT80",
    "profileYtVideoId": "0iW-UlQUTiE"
  },
  {
    "name": "Xitlali Olvera",
    "birthdate": "01/06/2002",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/764168645.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 154,
    "draftJersey": 77,
    "macros": {
      "physical": 82,
      "duels": 79,
      "shooting": 72,
      "defence": 93,
      "passing": 73,
      "skills": 70,
      "average": 78
    },
    "matchYtVideoId": "qUGNeZtyT80",
    "profileYtVideoId": "PKrrrtcDLmY"
  },
  {
    "name": "Alejandra Soto",
    "birthdate": "29/11/2002",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/97185748.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 158,
    "draftJersey": 78,
    "macros": {
      "physical": 80,
      "duels": 88,
      "shooting": 79,
      "defence": 92,
      "passing": 83,
      "skills": 70,
      "average": 82
    },
    "matchYtVideoId": "qUGNeZtyT80",
    "profileYtVideoId": "qzc-U__p6ro"
  },
  {
    "name": "Claudia Reyes",
    "birthdate": "21/10/1995",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/264526903.png",
    "country": "Mexico",
    "role": "DL",
    "foot": "right",
    "height": 163,
    "draftJersey": 79,
    "macros": {
      "physical": 82,
      "duels": 79,
      "shooting": 79,
      "defence": 84,
      "passing": 83,
      "skills": 98,
      "average": 83
    },
    "matchYtVideoId": "hC2FfzYwC6k",
    "profileYtVideoId": "9OGh0XeFpbQ"
  },
  {
    "name": "Ahtziri Montero",
    "birthdate": "24/11/1998",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/817571946.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "left",
    "height": 165,
    "draftJersey": 81,
    "macros": {
      "physical": 79,
      "duels": 67,
      "shooting": 67,
      "defence": 87,
      "passing": 64,
      "skills": 69,
      "average": 75
    },
    "matchYtVideoId": "qUGNeZtyT80",
    "profileYtVideoId": "oMrEXHMFIyo"
  },
  {
    "name": "Valeria Barranco",
    "birthdate": "11/04/1992",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/149564741.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "right",
    "height": 159,
    "draftJersey": 82,
    "macros": {
      "physical": 77,
      "duels": 74,
      "shooting": 69,
      "defence": 78,
      "passing": 83,
      "skills": 69,
      "average": 76
    },
    "matchYtVideoId": "hC2FfzYwC6k",
    "profileYtVideoId": "K6VpVx0a3nE"
  },
  {
    "name": "Ricla Rajunov",
    "birthdate": "14/01/1999",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/879865214.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 157,
    "draftJersey": 83,
    "macros": {
      "physical": 83,
      "duels": 79,
      "shooting": 76,
      "defence": 89,
      "passing": 93,
      "skills": 89,
      "average": 85
    },
    "matchYtVideoId": "hC2FfzYwC6k",
    "profileYtVideoId": "d4hH6UKrLKI"
  },
  {
    "name": "Natalia Guzmán",
    "birthdate": "09/11/2002",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/118100668.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 150,
    "draftJersey": 84,
    "macros": {
      "physical": 65,
      "duels": 69,
      "shooting": 62,
      "defence": 74,
      "passing": 76,
      "skills": 78,
      "average": 70
    },
    "matchYtVideoId": "hC2FfzYwC6k",
    "profileYtVideoId": "jGBcIg80e1Q"
  },
  {
    "name": "Daniela Bouchain",
    "birthdate": "27/08/2003",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/593473227.png",
    "country": "Mexico",
    "role": "DL",
    "foot": "right",
    "height": 160,
    "draftJersey": 85,
    "macros": {
      "physical": 88,
      "duels": 84,
      "shooting": 75,
      "defence": 83,
      "passing": 80,
      "skills": 70,
      "average": 79
    },
    "matchYtVideoId": "hC2FfzYwC6k",
    "profileYtVideoId": "qHdK4jCfkm8"
  },
  {
    "name": "Sophie Diaz",
    "birthdate": "11/10/1992",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/553513038.png",
    "country": "Mexico",
    "role": "DL",
    "foot": "right",
    "height": 162,
    "draftJersey": 86,
    "macros": {
      "physical": 61,
      "duels": 69,
      "shooting": 60,
      "defence": 60,
      "passing": 76,
      "skills": 78,
      "average": 66
    },
    "matchYtVideoId": "hC2FfzYwC6k",
    "profileYtVideoId": "-dqjJMakw3I"
  },
  {
    "name": "Citlalli Valencia",
    "birthdate": "04/04/2002",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/396174447.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "right",
    "height": 164,
    "draftJersey": 87,
    "macros": {
      "physical": 77,
      "duels": 79,
      "shooting": 67,
      "defence": 79,
      "passing": 84,
      "skills": 52,
      "average": 75
    },
    "matchYtVideoId": "hC2FfzYwC6k",
    "profileYtVideoId": "WhXKt25XgoY"
  },
  {
    "name": "María Gordillo",
    "birthdate": "03/04/1986",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/423885174.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "right",
    "height": 164,
    "draftJersey": 88,
    "macros": {
      "physical": 77,
      "duels": 92,
      "shooting": 79,
      "defence": 72,
      "passing": 87,
      "skills": 78,
      "average": 79
    },
    "matchYtVideoId": "hC2FfzYwC6k",
    "profileYtVideoId": "vWfs33pH2IQ"
  },
  {
    "name": "Roberta Jiménez",
    "birthdate": "28/10/1995",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/391867360.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 165,
    "draftJersey": 89,
    "macros": {
      "physical": 73,
      "duels": 65,
      "shooting": 71,
      "defence": 77,
      "passing": 68,
      "skills": 60,
      "average": 69
    },
    "matchYtVideoId": "hC2FfzYwC6k",
    "profileYtVideoId": "sLekBfW1HOM"
  },
  {
    "name": "Karen Argumedo",
    "birthdate": "12/08/2003",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/2034750.png",
    "country": "Mexico",
    "role": "DL",
    "foot": "right",
    "height": 164,
    "draftJersey": 91,
    "macros": {
      "physical": 74,
      "duels": 60,
      "shooting": 70,
      "defence": 74,
      "passing": 61,
      "skills": 60,
      "average": 67
    },
    "matchYtVideoId": "hC2FfzYwC6k",
    "profileYtVideoId": "Rgu3K-i7fbI"
  },
  {
    "name": "Diana Medina",
    "birthdate": "07/03/1997",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/619608829.png",
    "country": "Mexico",
    "role": "DL",
    "foot": "right",
    "height": 158,
    "draftJersey": 92,
    "macros": {
      "physical": 73,
      "duels": 60,
      "shooting": 61,
      "defence": 78,
      "passing": 77,
      "skills": 51,
      "average": 65
    },
    "matchYtVideoId": "hC2FfzYwC6k",
    "profileYtVideoId": "WXBS9FhMqtQ"
  },
  {
    "name": "Nataly Cárdenas",
    "birthdate": "14/07/2024",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/257879582.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "right",
    "height": 162,
    "draftJersey": 93,
    "macros": {
      "physical": 85,
      "duels": 66,
      "shooting": 72,
      "defence": 83,
      "passing": 84,
      "skills": 71,
      "average": 79
    },
    "matchYtVideoId": "EYCQv_QduwQ",
    "profileYtVideoId": "BigXPBxjGMA"
  },
  {
    "name": "Itzel López",
    "birthdate": "14/04/1998",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/216095061.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "right",
    "height": 152,
    "draftJersey": 94,
    "macros": {
      "physical": 79,
      "duels": 80,
      "shooting": 85,
      "defence": 83,
      "passing": 74,
      "skills": 80,
      "average": 81
    },
    "matchYtVideoId": "TuwUW9m_xWw",
    "profileYtVideoId": "ERG609bTO6I"
  },
  {
    "name": "Úrsula Reynoso",
    "birthdate": "19/06/1995",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/612716079.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 161,
    "draftJersey": 95,
    "macros": {
      "physical": 65,
      "duels": 56,
      "shooting": 69,
      "defence": 59,
      "passing": 72,
      "skills": 51,
      "average": 63
    },
    "matchYtVideoId": "EYCQv_QduwQ",
    "profileYtVideoId": "JE5TLf4GSuw"
  },
  {
    "name": "Blanca Rentería",
    "birthdate": "04/11/2004",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/199940735.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 160,
    "draftJersey": 96,
    "macros": {
      "physical": 77,
      "duels": 70,
      "shooting": 63,
      "defence": 85,
      "passing": 82,
      "skills": 70,
      "average": 74
    },
    "matchYtVideoId": "EYCQv_QduwQ",
    "profileYtVideoId": "4RWU93Tx8sU"
  },
  {
    "name": "Gabriela Molleda",
    "birthdate": "25/07/2000",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/554500483.png",
    "country": "Mexico",
    "role": "DL",
    "foot": "right",
    "height": 173,
    "draftJersey": 97,
    "macros": {
      "physical": 76,
      "duels": 78,
      "shooting": 71,
      "defence": 78,
      "passing": 66,
      "skills": 60,
      "average": 72
    },
    "matchYtVideoId": "EYCQv_QduwQ",
    "profileYtVideoId": "GdQZfBD9B4Y"
  },
  {
    "name": "Elaine Dorantes",
    "birthdate": "18/12/2002",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/494619183.png",
    "country": "Mexico",
    "role": "DL",
    "foot": "right",
    "height": 156,
    "draftJersey": 98,
    "macros": {
      "physical": 65,
      "duels": 65,
      "shooting": 60,
      "defence": 83,
      "passing": 57,
      "skills": 51,
      "average": 63
    },
    "matchYtVideoId": "EYCQv_QduwQ",
    "profileYtVideoId": "qS7uplfmmLw"
  },
  {
    "name": "Regina Terrés",
    "birthdate": "04/07/2003",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/521131658.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "right",
    "height": 167,
    "draftJersey": 99,
    "macros": {
      "physical": 77,
      "duels": 60,
      "shooting": 66,
      "defence": 82,
      "passing": 87,
      "skills": 60,
      "average": 75
    },
    "matchYtVideoId": "EYCQv_QduwQ",
    "profileYtVideoId": "l22fTuE5IvE"
  },
  {
    "name": "Zita Chao",
    "birthdate": "25/01/2001",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/508365895.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "right",
    "height": 171,
    "draftJersey": 100,
    "macros": {
      "physical": 74,
      "duels": 79,
      "shooting": 80,
      "defence": 70,
      "passing": 87,
      "skills": 97,
      "average": 78
    },
    "matchYtVideoId": "EYCQv_QduwQ",
    "profileYtVideoId": "lGaPAW8WEpU"
  },
  {
    "name": "Sharon Villegas",
    "birthdate": "09/07/2002",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/156646300.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 153,
    "draftJersey": 101,
    "macros": {
      "physical": 74,
      "duels": 51,
      "shooting": 60,
      "defence": 82,
      "passing": 76,
      "skills": 51,
      "average": 67
    },
    "matchYtVideoId": "EYCQv_QduwQ",
    "profileYtVideoId": "QYoE7yfi8XE"
  },
  {
    "name": "Julissa Torres",
    "birthdate": "31/07/1998",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/682482359.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 164,
    "draftJersey": 102,
    "macros": {
      "physical": 70,
      "duels": 70,
      "shooting": 78,
      "defence": 74,
      "passing": 84,
      "skills": 80,
      "average": 77
    },
    "matchYtVideoId": "EYCQv_QduwQ",
    "profileYtVideoId": "NH9bvptPMes"
  },
  {
    "name": "Daniela Méndez",
    "birthdate": "19/04/1991",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/917137219.png",
    "country": "Mexico",
    "role": "DL",
    "foot": "right",
    "height": 160,
    "draftJersey": 103,
    "macros": {
      "physical": 65,
      "duels": 61,
      "shooting": 74,
      "defence": 83,
      "passing": 70,
      "skills": 79,
      "average": 71
    },
    "matchYtVideoId": "EYCQv_QduwQ",
    "profileYtVideoId": "cku-nAKhKzo"
  },
  {
    "name": "Brenda Leal",
    "birthdate": "25/02/2002",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/115158748.png",
    "country": "Mexico",
    "role": "DL",
    "foot": "left",
    "height": 163,
    "draftJersey": 104,
    "macros": {
      "physical": 77,
      "duels": 79,
      "shooting": 74,
      "defence": 84,
      "passing": 88,
      "skills": 88,
      "average": 80
    },
    "matchYtVideoId": "EYCQv_QduwQ",
    "profileYtVideoId": "9K6Yj-zw9ok"
  },
  {
    "name": "Franchesca Salmerón",
    "birthdate": "18/01/1997",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/614731396.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "right",
    "height": 165,
    "draftJersey": 105,
    "macros": {
      "physical": 83,
      "duels": 75,
      "shooting": 72,
      "defence": 84,
      "passing": 75,
      "skills": 79,
      "average": 79
    },
    "matchYtVideoId": "TuwUW9m_xWw",
    "profileYtVideoId": "CXR02uMU8uU"
  },
  {
    "name": "Zaira Moreno",
    "birthdate": "22/07/2003",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/801397768.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 162,
    "draftJersey": 107,
    "macros": {
      "physical": 75,
      "duels": 97,
      "shooting": 77,
      "defence": 75,
      "passing": 87,
      "skills": 89,
      "average": 83
    },
    "matchYtVideoId": "TuwUW9m_xWw",
    "profileYtVideoId": "1x17xoR1-t8"
  },
  {
    "name": "Paulina Aguilar",
    "birthdate": "03/05/1998",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/980965151.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 158,
    "draftJersey": 108,
    "macros": {
      "physical": 71,
      "duels": 70,
      "shooting": 80,
      "defence": 79,
      "passing": 80,
      "skills": 62,
      "average": 75
    },
    "matchYtVideoId": "TuwUW9m_xWw",
    "profileYtVideoId": "O196DYL4r4M"
  },
  {
    "name": "Nora Garcia",
    "birthdate": "10/10/2001",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/883950774.png",
    "country": "Mexico",
    "role": "DL",
    "foot": "right",
    "height": 162,
    "draftJersey": 109,
    "macros": {
      "physical": 65,
      "duels": 60,
      "shooting": 62,
      "defence": 60,
      "passing": 72,
      "skills": 51,
      "average": 62
    },
    "matchYtVideoId": "EYCQv_QduwQ",
    "profileYtVideoId": "-9N35IPKcWA"
  },
  {
    "name": "Guadalupe Bernal",
    "birthdate": "14/11/1989",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/581792704.png",
    "country": "Mexico",
    "role": "DL",
    "foot": "right",
    "height": 165,
    "draftJersey": 110,
    "macros": {
      "physical": 70,
      "duels": 69,
      "shooting": 70,
      "defence": 60,
      "passing": 71,
      "skills": 60,
      "average": 67
    },
    "matchYtVideoId": "TuwUW9m_xWw",
    "profileYtVideoId": "eRGMuTG_fl4"
  },
  {
    "name": "Diana Lledias",
    "birthdate": "20/01/1998",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/133199578.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "right",
    "height": 179,
    "draftJersey": 111,
    "macros": {
      "physical": 74,
      "duels": 64,
      "shooting": 60,
      "defence": 68,
      "passing": 87,
      "skills": 69,
      "average": 71
    },
    "matchYtVideoId": "TuwUW9m_xWw",
    "profileYtVideoId": "Rjq7VR6fuig"
  },
  {
    "name": "María Sánchez",
    "birthdate": "05/11/1998",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/290085799.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "right",
    "height": 160,
    "draftJersey": 112,
    "macros": {
      "physical": 73,
      "duels": 76,
      "shooting": 80,
      "defence": 84,
      "passing": 78,
      "skills": 70,
      "average": 78
    },
    "matchYtVideoId": "TuwUW9m_xWw",
    "profileYtVideoId": "cLlN-0nKVbI"
  },
  {
    "name": "Yariko Delgado",
    "birthdate": "04/09/1996",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/102298982.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 164,
    "draftJersey": 113,
    "macros": {
      "physical": 73,
      "duels": 61,
      "shooting": 83,
      "defence": 83,
      "passing": 89,
      "skills": 52,
      "average": 72
    },
    "matchYtVideoId": "TuwUW9m_xWw",
    "profileYtVideoId": "NS0JZsrhcSM"
  },
  {
    "name": "Angelica Juárez",
    "birthdate": "26/11/1996",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/548061545.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 172,
    "draftJersey": 114,
    "macros": {
      "physical": 72,
      "duels": 78,
      "shooting": 72,
      "defence": 78,
      "passing": 77,
      "skills": 69,
      "average": 75
    },
    "matchYtVideoId": "TuwUW9m_xWw",
    "profileYtVideoId": "0MBtjuPW3Z4"
  },
  {
    "name": "Florencia von Wernich",
    "birthdate": "28/03/1998",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/884377786.png",
    "country": "Argentina",
    "role": "DL",
    "foot": "right",
    "height": 166,
    "draftJersey": 115,
    "macros": {
      "physical": 65,
      "duels": 60,
      "shooting": 60,
      "defence": 78,
      "passing": 61,
      "skills": 60,
      "average": 63
    },
    "matchYtVideoId": "TuwUW9m_xWw",
    "profileYtVideoId": "GLxoGm4vnUY"
  },
  {
    "name": "Karen Aquino",
    "birthdate": "07/06/2001",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/671627908.png",
    "country": "Mexico",
    "role": "DL",
    "foot": "left",
    "height": 164,
    "draftJersey": 116,
    "macros": {
      "physical": 75,
      "duels": 61,
      "shooting": 63,
      "defence": 65,
      "passing": 82,
      "skills": 61,
      "average": 66
    },
    "matchYtVideoId": "TuwUW9m_xWw",
    "profileYtVideoId": "8p1LOn8pEbg"
  },
  {
    "name": "Lidia Pérez",
    "birthdate": "25/08/2001",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/943922111.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "right",
    "height": 163,
    "draftJersey": 127,
    "macros": {
      "physical": 80,
      "duels": 55,
      "shooting": 59,
      "defence": 64,
      "passing": 55,
      "skills": 51,
      "average": 63
    },
    "matchYtVideoId": "k_xkGU_7Vb0",
    "profileYtVideoId": "NlUH3Vqv4k4"
  },
  {
    "name": "Mia Martínez",
    "birthdate": "23/11/2005",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/325199451.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "right",
    "height": 168,
    "draftJersey": 128,
    "macros": {
      "physical": 66,
      "duels": 59,
      "shooting": 71,
      "defence": 80,
      "passing": 83,
      "skills": 52,
      "average": 71
    },
    "matchYtVideoId": "k_xkGU_7Vb0",
    "profileYtVideoId": "Dea4JIhoG_0"
  },
  {
    "name": "Liliana Orozco",
    "birthdate": "20/05/2024",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/959215815.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 162,
    "draftJersey": 129,
    "macros": {
      "physical": 72,
      "duels": 78,
      "shooting": 70,
      "defence": 78,
      "passing": 76,
      "skills": 88,
      "average": 76
    },
    "matchYtVideoId": "k_xkGU_7Vb0",
    "profileYtVideoId": "8VMuIcLJ_E4"
  },
  {
    "name": "Leslie Castaneda",
    "birthdate": "17/08/1985",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/158478841.png",
    "country": "Mexico",
    "role": "DL",
    "foot": "left",
    "height": 160,
    "draftJersey": 132,
    "macros": {
      "physical": 67,
      "duels": 66,
      "shooting": 79,
      "defence": 87,
      "passing": 82,
      "skills": 70,
      "average": 75
    },
    "matchYtVideoId": "k_xkGU_7Vb0",
    "profileYtVideoId": "lLfdqn4HDQI"
  },
  {
    "name": "Brenda López",
    "birthdate": "31/03/1999",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/62333980.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "right",
    "height": 160,
    "draftJersey": 133,
    "macros": {
      "physical": 83,
      "duels": 69,
      "shooting": 70,
      "defence": 87,
      "passing": 69,
      "skills": 61,
      "average": 77
    },
    "matchYtVideoId": "k_xkGU_7Vb0",
    "profileYtVideoId": "172wJWBb6c4"
  },
  {
    "name": "Alma Barrera",
    "birthdate": "16/06/1989",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/214342775.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 153,
    "draftJersey": 135,
    "macros": {
      "physical": 78,
      "duels": 84,
      "shooting": 72,
      "defence": 84,
      "passing": 73,
      "skills": 80,
      "average": 78
    },
    "matchYtVideoId": "k_xkGU_7Vb0",
    "profileYtVideoId": "-pAQy_R-_go"
  },
  {
    "name": "Daniela Pallares",
    "birthdate": "13/11/1997",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/518178738.png",
    "country": "Mexico",
    "role": "DL",
    "foot": "right",
    "height": 158,
    "draftJersey": 137,
    "macros": {
      "physical": 80,
      "duels": 78,
      "shooting": 71,
      "defence": 83,
      "passing": 88,
      "skills": 79,
      "average": 78
    },
    "matchYtVideoId": "k_xkGU_7Vb0",
    "profileYtVideoId": "rZSZ1Q3pEuo"
  },
  {
    "name": "Maria Ulloa",
    "birthdate": "09/03/2003",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/853594802.png",
    "country": "Mexico",
    "role": "DL",
    "foot": "left",
    "height": 161,
    "draftJersey": 138,
    "macros": {
      "physical": 74,
      "duels": 78,
      "shooting": 65,
      "defence": 75,
      "passing": 66,
      "skills": 61,
      "average": 69
    },
    "matchYtVideoId": "k_xkGU_7Vb0",
    "profileYtVideoId": "9TqKrhKcS-8"
  },
  {
    "name": "Tania Salgado",
    "birthdate": "06/11/1999",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/197219366.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "right",
    "height": 159,
    "draftJersey": 140,
    "macros": {
      "physical": 88,
      "duels": 66,
      "shooting": 68,
      "defence": 84,
      "passing": 83,
      "skills": 97,
      "average": 82
    },
    "matchYtVideoId": "qRr6SQ4UCB0",
    "profileYtVideoId": "jA-XayHRenY"
  },
  {
    "name": "Valeria Sánchez",
    "birthdate": "14/02/2006",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/477629676.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 169,
    "draftJersey": 141,
    "macros": {
      "physical": 62,
      "duels": 60,
      "shooting": 56,
      "defence": 72,
      "passing": 83,
      "skills": 97,
      "average": 71
    },
    "matchYtVideoId": "qRr6SQ4UCB0",
    "profileYtVideoId": "J0dkuUn_hbk"
  },
  {
    "name": "Guadalupe Diaz",
    "birthdate": "14/02/2000",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/218188591.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 151,
    "draftJersey": 142,
    "macros": {
      "physical": 66,
      "duels": 74,
      "shooting": 63,
      "defence": 72,
      "passing": 86,
      "skills": 69,
      "average": 72
    },
    "matchYtVideoId": "qRr6SQ4UCB0",
    "profileYtVideoId": "IvW6Lu7Ym2A"
  },
  {
    "name": "Nathaly Losada",
    "birthdate": "08/06/1991",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/250284706.png",
    "country": "Colombia",
    "role": "DL",
    "foot": "right",
    "height": 164,
    "draftJersey": 143,
    "macros": {
      "physical": 91,
      "duels": 70,
      "shooting": 80,
      "defence": 83,
      "passing": 93,
      "skills": 97,
      "average": 84
    },
    "matchYtVideoId": "qRr6SQ4UCB0",
    "profileYtVideoId": "xfVkQf57DI0"
  },
  {
    "name": "Zara Hernández",
    "birthdate": "23/06/2000",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/759411317.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 160,
    "draftJersey": 144,
    "macros": {
      "physical": 72,
      "duels": 78,
      "shooting": 71,
      "defence": 82,
      "passing": 82,
      "skills": 60,
      "average": 74
    },
    "matchYtVideoId": "qRr6SQ4UCB0",
    "profileYtVideoId": "yhFIAjXVyGU"
  },
  {
    "name": "Jazmin Romero",
    "birthdate": "04/01/2001",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/680240413.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 166,
    "draftJersey": 145,
    "macros": {
      "physical": 65,
      "duels": 74,
      "shooting": 75,
      "defence": 77,
      "passing": 67,
      "skills": 69,
      "average": 71
    },
    "matchYtVideoId": "qRr6SQ4UCB0",
    "profileYtVideoId": "vVPt8SGif9w"
  },
  {
    "name": "Ana De María",
    "birthdate": "22/10/1998",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/19039320.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "left",
    "height": 162,
    "draftJersey": 146,
    "macros": {
      "physical": 78,
      "duels": 79,
      "shooting": 84,
      "defence": 93,
      "passing": 76,
      "skills": 88,
      "average": 83
    },
    "matchYtVideoId": "k_xkGU_7Vb0",
    "profileYtVideoId": "51HnP0VODoo"
  },
  {
    "name": "Juana Guerrero",
    "birthdate": "18/01/2002",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/773202171.png",
    "country": "Argentina",
    "role": "MC",
    "foot": "right",
    "height": 166,
    "draftJersey": 148,
    "macros": {
      "physical": 66,
      "duels": 88,
      "shooting": 86,
      "defence": 92,
      "passing": 78,
      "skills": 79,
      "average": 82
    },
    "matchYtVideoId": "qRr6SQ4UCB0",
    "profileYtVideoId": "fVxnQnFJPTs"
  },
  {
    "name": "Dana García",
    "birthdate": "11/06/2002",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/621502318.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "left",
    "height": 165,
    "draftJersey": 149,
    "macros": {
      "physical": 93,
      "duels": 83,
      "shooting": 60,
      "defence": 87,
      "passing": 69,
      "skills": 69,
      "average": 75
    },
    "matchYtVideoId": "qRr6SQ4UCB0",
    "profileYtVideoId": "SlN7tXALPPc"
  },
  {
    "name": "Ana Morales",
    "birthdate": "14/07/1997",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/470936955.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 154,
    "draftJersey": 150,
    "macros": {
      "physical": 69,
      "duels": 61,
      "shooting": 62,
      "defence": 69,
      "passing": 68,
      "skills": 52,
      "average": 64
    },
    "matchYtVideoId": "k_xkGU_7Vb0",
    "profileYtVideoId": "s-EID7C9GF4"
  },
  {
    "name": "María Tovar",
    "birthdate": "22/12/2000",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/989852564.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "right",
    "height": 157,
    "draftJersey": 151,
    "macros": {
      "physical": 78,
      "duels": 70,
      "shooting": 78,
      "defence": 83,
      "passing": 88,
      "skills": 70,
      "average": 79
    },
    "matchYtVideoId": "Yvbs_C-Wc9w",
    "profileYtVideoId": "SkLfAVaWXyk"
  },
  {
    "name": "Karla Salcedo",
    "birthdate": "26/01/1996",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/857822136.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 160,
    "draftJersey": 152,
    "macros": {
      "physical": 67,
      "duels": 74,
      "shooting": 78,
      "defence": 87,
      "passing": 72,
      "skills": 61,
      "average": 73
    },
    "matchYtVideoId": "Yvbs_C-Wc9w",
    "profileYtVideoId": "INfqoezx6_0"
  },
  {
    "name": "Andrea Contreras",
    "birthdate": "19/01/1995",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/959959645.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 162,
    "draftJersey": 153,
    "macros": {
      "physical": 74,
      "duels": 61,
      "shooting": 73,
      "defence": 70,
      "passing": 79,
      "skills": 61,
      "average": 70
    },
    "matchYtVideoId": "Yvbs_C-Wc9w",
    "profileYtVideoId": "XIJjc05VFr8"
  },
  {
    "name": "Carla Paez",
    "birthdate": "05/07/1994",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/868174231.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "left",
    "height": 163,
    "draftJersey": 154,
    "macros": {
      "physical": 66,
      "duels": 69,
      "shooting": 70,
      "defence": 74,
      "passing": 87,
      "skills": 69,
      "average": 73
    },
    "matchYtVideoId": "Yvbs_C-Wc9w",
    "profileYtVideoId": "mZ01R8hnfzI"
  },
  {
    "name": "Rubi Gómez",
    "birthdate": "25/06/1996",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/12068686.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 155,
    "draftJersey": 155,
    "macros": {
      "physical": 73,
      "duels": 84,
      "shooting": 75,
      "defence": 66,
      "passing": 87,
      "skills": 97,
      "average": 80
    },
    "matchYtVideoId": "Yvbs_C-Wc9w",
    "profileYtVideoId": "6KJF1azrQSw"
  },
  {
    "name": "Jibely Tagle",
    "birthdate": "04/02/2000",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/497640032.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 158,
    "draftJersey": 156,
    "macros": {
      "physical": 76,
      "duels": 87,
      "shooting": 87,
      "defence": 87,
      "passing": 77,
      "skills": 88,
      "average": 84
    },
    "matchYtVideoId": "Yvbs_C-Wc9w",
    "profileYtVideoId": "GcwK72dkRGo"
  },
  {
    "name": "Marisol Vega",
    "birthdate": "30/08/1999",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/416413747.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 153,
    "draftJersey": 157,
    "macros": {
      "physical": 65,
      "duels": 65,
      "shooting": 62,
      "defence": 64,
      "passing": 73,
      "skills": 78,
      "average": 68
    },
    "matchYtVideoId": "Yvbs_C-Wc9w",
    "profileYtVideoId": "kMKWEuKuu0Y"
  },
  {
    "name": "Ofelia Chávez",
    "birthdate": "24/11/2000",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/540868988.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 170,
    "draftJersey": 158,
    "macros": {
      "physical": 77,
      "duels": 75,
      "shooting": 83,
      "defence": 84,
      "passing": 82,
      "skills": 70,
      "average": 79
    },
    "matchYtVideoId": "Yvbs_C-Wc9w",
    "profileYtVideoId": "BNfswqnfDW4"
  },
  {
    "name": "Ana Guzmán",
    "birthdate": "21/02/1997",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/276533051.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 157,
    "draftJersey": 160,
    "macros": {
      "physical": 70,
      "duels": 78,
      "shooting": 66,
      "defence": 65,
      "passing": 75,
      "skills": 70,
      "average": 71
    },
    "matchYtVideoId": "Yvbs_C-Wc9w",
    "profileYtVideoId": "daaNmCov_68"
  },
  {
    "name": "Arizbeth Ramos",
    "birthdate": "03/07/1995",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/643613140.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "left",
    "height": 164,
    "draftJersey": 161,
    "macros": {
      "physical": 78,
      "duels": 74,
      "shooting": 66,
      "defence": 63,
      "passing": 86,
      "skills": 70,
      "average": 73
    },
    "matchYtVideoId": "Yvbs_C-Wc9w",
    "profileYtVideoId": "mhlV1YmvN90"
  },
  {
    "name": "Laura Ortiz",
    "birthdate": "13/12/2001",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/194616191.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 165,
    "draftJersey": 162,
    "macros": {
      "physical": 78,
      "duels": 65,
      "shooting": 66,
      "defence": 78,
      "passing": 86,
      "skills": 61,
      "average": 73
    },
    "matchYtVideoId": "Yvbs_C-Wc9w",
    "profileYtVideoId": "GG7ndQscWUU"
  },
  {
    "name": "Andrea Colin",
    "birthdate": "25/10/2000",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/671109833.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 162,
    "draftJersey": 163,
    "macros": {
      "physical": 72,
      "duels": 65,
      "shooting": 60,
      "defence": 78,
      "passing": 87,
      "skills": 60,
      "average": 70
    },
    "matchYtVideoId": "d7CMZsyIIKE",
    "profileYtVideoId": "sEbRExqjE9g"
  },
  {
    "name": "Patricia Serrano",
    "birthdate": "03/07/2000",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/392957661.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 170,
    "draftJersey": 164,
    "macros": {
      "physical": 90,
      "duels": 69,
      "shooting": 71,
      "defence": 78,
      "passing": 83,
      "skills": 69,
      "average": 77
    },
    "matchYtVideoId": "d7CMZsyIIKE",
    "profileYtVideoId": "eCyhOPn3FXg"
  },
  {
    "name": "América Rubio",
    "birthdate": "27/05/2001",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/336958003.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "left",
    "height": 157,
    "draftJersey": 165,
    "macros": {
      "physical": 84,
      "duels": 75,
      "shooting": 79,
      "defence": 84,
      "passing": 78,
      "skills": 70,
      "average": 78
    },
    "matchYtVideoId": "d7CMZsyIIKE",
    "profileYtVideoId": "erjPoRA3ZNQ"
  },
  {
    "name": "Shaden García",
    "birthdate": "21/01/2001",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/214591270.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 157,
    "draftJersey": 168,
    "macros": {
      "physical": 61,
      "duels": 69,
      "shooting": 78,
      "defence": 78,
      "passing": 66,
      "skills": 69,
      "average": 70
    },
    "matchYtVideoId": "d7CMZsyIIKE",
    "profileYtVideoId": "faFsPBhWkfY"
  },
  {
    "name": "Eila Cebreros",
    "birthdate": "21/02/1999",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/171524908.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 160,
    "draftJersey": 169,
    "macros": {
      "physical": 77,
      "duels": 69,
      "shooting": 78,
      "defence": 91,
      "passing": 83,
      "skills": 79,
      "average": 80
    },
    "matchYtVideoId": "d7CMZsyIIKE",
    "profileYtVideoId": "lztjt0ohMlg"
  },
  {
    "name": "Andrea Sánchez",
    "birthdate": "20/07/2000",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/308887674.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 166,
    "draftJersey": 170,
    "macros": {
      "physical": 74,
      "duels": 74,
      "shooting": 72,
      "defence": 82,
      "passing": 84,
      "skills": 70,
      "average": 76
    },
    "matchYtVideoId": "d7CMZsyIIKE",
    "profileYtVideoId": "97K-wOvaqM0"
  },
  {
    "name": "Imelda Martínez",
    "birthdate": "13/05/1995",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/133337568.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 160,
    "draftJersey": 171,
    "macros": {
      "physical": 88,
      "duels": 70,
      "shooting": 78,
      "defence": 84,
      "passing": 82,
      "skills": 88,
      "average": 82
    },
    "matchYtVideoId": "d7CMZsyIIKE",
    "profileYtVideoId": "slG200AU6xQ"
  },
  {
    "name": "Daniela Sánchez",
    "birthdate": "16/10/2003",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/668744446.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 163,
    "draftJersey": 172,
    "macros": {
      "physical": 65,
      "duels": 74,
      "shooting": 74,
      "defence": 56,
      "passing": 76,
      "skills": 79,
      "average": 71
    },
    "matchYtVideoId": "d7CMZsyIIKE",
    "profileYtVideoId": "HcOAleYqZkE"
  },
  {
    "name": "Alexandra Gallegos",
    "birthdate": "11/09/1999",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/673187795.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 164,
    "draftJersey": 173,
    "macros": {
      "physical": 81,
      "duels": 83,
      "shooting": 78,
      "defence": 70,
      "passing": 74,
      "skills": 97,
      "average": 80
    },
    "matchYtVideoId": "d7CMZsyIIKE",
    "profileYtVideoId": "Y48MTCr1AL4"
  },
  {
    "name": "Fernanda Rosales",
    "birthdate": "05/09/2002",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/513814051.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 165,
    "draftJersey": 174,
    "macros": {
      "physical": 90,
      "duels": 74,
      "shooting": 66,
      "defence": 82,
      "passing": 73,
      "skills": 60,
      "average": 74
    },
    "matchYtVideoId": "d7CMZsyIIKE",
    "profileYtVideoId": "Awh89Zp6fCw"
  },
  {
    "name": "Karen Escamilla",
    "birthdate": "10/07/1999",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/57912277.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 162,
    "draftJersey": 185,
    "macros": {
      "physical": 78,
      "duels": 79,
      "shooting": 77,
      "defence": 92,
      "passing": 74,
      "skills": 79,
      "average": 79
    },
    "matchYtVideoId": "gcbtA9h0Ul4",
    "profileYtVideoId": "9S3-_z84gEE"
  },
  {
    "name": "Sagrario Ortiz",
    "birthdate": "07/11/2001",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/405759542.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 159,
    "draftJersey": 186,
    "macros": {
      "physical": 78,
      "duels": 74,
      "shooting": 78,
      "defence": 88,
      "passing": 96,
      "skills": 60,
      "average": 80
    },
    "matchYtVideoId": "gcbtA9h0Ul4",
    "profileYtVideoId": "NFjJ7njFdxc"
  },
  {
    "name": "Frida García",
    "birthdate": "18/01/2001",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/848722884.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 158,
    "draftJersey": 188,
    "macros": {
      "physical": 77,
      "duels": 74,
      "shooting": 69,
      "defence": 92,
      "passing": 91,
      "skills": 69,
      "average": 79
    },
    "matchYtVideoId": "gcbtA9h0Ul4",
    "profileYtVideoId": "O8PE5KlJXCA"
  },
  {
    "name": "Denisse García",
    "birthdate": "03/12/2004",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/781023034.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 164,
    "draftJersey": 189,
    "macros": {
      "physical": 76,
      "duels": 78,
      "shooting": 73,
      "defence": 77,
      "passing": 91,
      "skills": 73,
      "average": 79
    },
    "matchYtVideoId": "gcbtA9h0Ul4",
    "profileYtVideoId": "EOwfEbA_i08"
  },
  {
    "name": "Paola Castañón",
    "birthdate": "10/09/2003",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/972679219.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 150,
    "draftJersey": 190,
    "macros": {
      "physical": 91,
      "duels": 74,
      "shooting": 66,
      "defence": 92,
      "passing": 83,
      "skills": 88,
      "average": 82
    },
    "matchYtVideoId": "gcbtA9h0Ul4",
    "profileYtVideoId": "iyS3nypLXS8"
  },
  {
    "name": "Hazel Hurtado",
    "birthdate": "18/08/2022",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/789563346.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "left",
    "height": 157,
    "draftJersey": 191,
    "macros": {
      "physical": 75,
      "duels": 66,
      "shooting": 62,
      "defence": 79,
      "passing": 87,
      "skills": 70,
      "average": 73
    },
    "matchYtVideoId": "gcbtA9h0Ul4",
    "profileYtVideoId": "RkKD43h04fs"
  },
  {
    "name": "Bredka Morales",
    "birthdate": "16/02/1999",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/257770888.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 150,
    "draftJersey": 192,
    "macros": {
      "physical": 71,
      "duels": 70,
      "shooting": 68,
      "defence": 70,
      "passing": 77,
      "skills": 52,
      "average": 68
    },
    "matchYtVideoId": "gcbtA9h0Ul4",
    "profileYtVideoId": "vxESA4T0ezI"
  },
  {
    "name": "Kimberly Bañuelos",
    "birthdate": "12/08/1996",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/219722767.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 167,
    "draftJersey": 194,
    "macros": {
      "physical": 76,
      "duels": 65,
      "shooting": 60,
      "defence": 73,
      "passing": 57,
      "skills": 51,
      "average": 64
    },
    "matchYtVideoId": "gcbtA9h0Ul4",
    "profileYtVideoId": "D6SRqSGbWn4"
  },
  {
    "name": "Roxana Torres",
    "birthdate": "23/01/2003",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/139094294.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 162,
    "draftJersey": 195,
    "macros": {
      "physical": 90,
      "duels": 79,
      "shooting": 77,
      "defence": 78,
      "passing": 89,
      "skills": 80,
      "average": 82
    },
    "matchYtVideoId": "gcbtA9h0Ul4",
    "profileYtVideoId": "RwVZdYZDuKM"
  },
  {
    "name": "Mayra Perales",
    "birthdate": "11/01/2004",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/636161054.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 160,
    "draftJersey": 196,
    "macros": {
      "physical": 68,
      "duels": 60,
      "shooting": 64,
      "defence": 76,
      "passing": 81,
      "skills": 60,
      "average": 69
    },
    "matchYtVideoId": "gcbtA9h0Ul4",
    "profileYtVideoId": "lXcKEpLyzN4"
  },
  {
    "name": "Ana Thaily",
    "birthdate": "04/07/2002",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/638960212.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "left",
    "height": 167,
    "draftJersey": 197,
    "macros": {
      "physical": 83,
      "duels": 74,
      "shooting": 72,
      "defence": 78,
      "passing": 82,
      "skills": 87,
      "average": 79
    },
    "matchYtVideoId": "eQUQaES3w7M",
    "profileYtVideoId": "hgQRL7Z_Bw0"
  },
  {
    "name": "Xanath Rodríguez",
    "birthdate": "05/10/1997",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/208149788.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "left",
    "height": 160,
    "draftJersey": 198,
    "macros": {
      "physical": 84,
      "duels": 55,
      "shooting": 65,
      "defence": 69,
      "passing": 61,
      "skills": 59,
      "average": 65
    },
    "matchYtVideoId": "k_xkGU_7Vb0",
    "profileYtVideoId": "p-3QFh9iRTI"
  },
  {
    "name": "Esli Sánchez",
    "birthdate": "26/06/1992",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/281908905.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 160,
    "draftJersey": 199,
    "macros": {
      "physical": 83,
      "duels": 83,
      "shooting": 65,
      "defence": 74,
      "passing": 73,
      "skills": 69,
      "average": 74
    },
    "matchYtVideoId": "eQUQaES3w7M",
    "profileYtVideoId": "01S4BFeCqE8"
  },
  {
    "name": "Paula Atilano",
    "birthdate": "30/03/2000",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/886478212.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 161,
    "draftJersey": 200,
    "macros": {
      "physical": 81,
      "duels": 75,
      "shooting": 68,
      "defence": 88,
      "passing": 84,
      "skills": 98,
      "average": 82
    },
    "matchYtVideoId": "eQUQaES3w7M",
    "profileYtVideoId": "yjBKGFxa1KY"
  },
  {
    "name": "Elizabeth Carbajal",
    "birthdate": "06/10/1994",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/687187098.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "left",
    "height": 153,
    "draftJersey": 201,
    "macros": {
      "physical": 70,
      "duels": 61,
      "shooting": 61,
      "defence": 88,
      "passing": 74,
      "skills": 61,
      "average": 69
    },
    "matchYtVideoId": "eQUQaES3w7M",
    "profileYtVideoId": "7an-08-nLwM"
  },
  {
    "name": "Danna García",
    "birthdate": "07/09/2005",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/69163882.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 156,
    "draftJersey": 202,
    "macros": {
      "physical": 85,
      "duels": 75,
      "shooting": 76,
      "defence": 79,
      "passing": 78,
      "skills": 52,
      "average": 74
    },
    "matchYtVideoId": "eQUQaES3w7M",
    "profileYtVideoId": "VLT_OBROtE4"
  },
  {
    "name": "Ana Ramírez",
    "birthdate": "16/11/2000",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/892286984.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 170,
    "draftJersey": 203,
    "macros": {
      "physical": 78,
      "duels": 61,
      "shooting": 62,
      "defence": 73,
      "passing": 61,
      "skills": 52,
      "average": 64
    },
    "matchYtVideoId": "eQUQaES3w7M",
    "profileYtVideoId": "X5YEs39S6c8"
  },
  {
    "name": "Areli Gutiérrez",
    "birthdate": "14/03/2004",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/587671996.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "left",
    "height": 163,
    "draftJersey": 204,
    "macros": {
      "physical": 81,
      "duels": 57,
      "shooting": 62,
      "defence": 79,
      "passing": 79,
      "skills": 61,
      "average": 70
    },
    "matchYtVideoId": "eQUQaES3w7M",
    "profileYtVideoId": "KxoORDqER_Y"
  },
  {
    "name": "Jaqueline Quintana",
    "birthdate": "30/10/1999",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/142335893.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "left",
    "height": 163,
    "draftJersey": 205,
    "macros": {
      "physical": 82,
      "duels": 56,
      "shooting": 60,
      "defence": 64,
      "passing": 82,
      "skills": 51,
      "average": 66
    },
    "matchYtVideoId": "eQUQaES3w7M",
    "profileYtVideoId": "lhSfFa4_nho"
  },
  {
    "name": "Karla Padilla",
    "birthdate": "08/12/1996",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/656188789.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 155,
    "draftJersey": 206,
    "macros": {
      "physical": 81,
      "duels": 70,
      "shooting": 67,
      "defence": 88,
      "passing": 83,
      "skills": 70,
      "average": 77
    },
    "matchYtVideoId": "eQUQaES3w7M",
    "profileYtVideoId": "VslCQ5gaOlc"
  },
  {
    "name": "Yuridia Zacarías",
    "birthdate": "14/06/2005",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/724615718.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 167,
    "draftJersey": 209,
    "macros": {
      "physical": 82,
      "duels": 65,
      "shooting": 66,
      "defence": 87,
      "passing": 68,
      "skills": 69,
      "average": 72
    },
    "matchYtVideoId": "EYCQv_QduwQ",
    "profileYtVideoId": "Gn-OR6_0P4Q"
  },
  {
    "name": "Paola Aguilar",
    "birthdate": "13/10/1997",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/865070025.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 160,
    "draftJersey": 210,
    "macros": {
      "physical": 69,
      "duels": 60,
      "shooting": 60,
      "defence": 63,
      "passing": 69,
      "skills": 60,
      "average": 63
    },
    "matchYtVideoId": "tdUT4iDTXcY",
    "profileYtVideoId": "vCzkotYPtlM"
  },
  {
    "name": "Mariana Rodríguez",
    "birthdate": "30/04/1991",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/275722310.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 156,
    "draftJersey": 211,
    "macros": {
      "physical": 77,
      "duels": 70,
      "shooting": 73,
      "defence": 79,
      "passing": 94,
      "skills": 80,
      "average": 79
    },
    "matchYtVideoId": "F_bjbMAGMz8",
    "profileYtVideoId": "s_XWSjRQwV4"
  },
  {
    "name": "Ana Aranda",
    "birthdate": "26/01/2002",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/752886245.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "right",
    "height": 158,
    "draftJersey": 215,
    "macros": {
      "physical": 77,
      "duels": 69,
      "shooting": 67,
      "defence": 73,
      "passing": 74,
      "skills": 69,
      "average": 72
    },
    "matchYtVideoId": "tdUT4iDTXcY",
    "profileYtVideoId": "lTIgWZl1ZnU"
  },
  {
    "name": "Diana Martínez",
    "birthdate": "03/08/1993",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/513731853.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "right",
    "height": 160,
    "draftJersey": 216,
    "macros": {
      "physical": 75,
      "duels": 70,
      "shooting": 83,
      "defence": 68,
      "passing": 88,
      "skills": 97,
      "average": 78
    },
    "matchYtVideoId": "tdUT4iDTXcY",
    "profileYtVideoId": "AD2VXx13DWk"
  },
  {
    "name": "Brenda Blanquel",
    "birthdate": "22/11/1994",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/105354119.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 160,
    "draftJersey": 217,
    "macros": {
      "physical": 86,
      "duels": 84,
      "shooting": 80,
      "defence": 75,
      "passing": 87,
      "skills": 98,
      "average": 85
    },
    "matchYtVideoId": "tdUT4iDTXcY",
    "profileYtVideoId": "oqZgthSDbe0"
  },
  {
    "name": "Andrea Godínez",
    "birthdate": "12/03/2004",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/38468787.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 156,
    "draftJersey": 218,
    "macros": {
      "physical": 75,
      "duels": 75,
      "shooting": 70,
      "defence": 74,
      "passing": 84,
      "skills": 79,
      "average": 76
    },
    "matchYtVideoId": "tdUT4iDTXcY",
    "profileYtVideoId": "TQh9FVD4cjo"
  },
  {
    "name": "Alondra Marquez",
    "birthdate": "17/07/2003",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/839846844.png",
    "country": "Mexico",
    "role": "DL",
    "foot": "right",
    "height": 164,
    "draftJersey": 220,
    "macros": {
      "physical": 83,
      "duels": 75,
      "shooting": 67,
      "defence": 79,
      "passing": 78,
      "skills": 79,
      "average": 75
    },
    "matchYtVideoId": "tdUT4iDTXcY",
    "profileYtVideoId": "jQWo1Miuo80"
  },
  {
    "name": "Samantha Martínez",
    "birthdate": "15/01/1997",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/416343304.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "right",
    "height": 164,
    "draftJersey": 227,
    "macros": {
      "physical": 76,
      "duels": 67,
      "shooting": 74,
      "defence": 76,
      "passing": 88,
      "skills": 80,
      "average": 77
    },
    "matchYtVideoId": "laA7GmRJkLM",
    "profileYtVideoId": "HRwUA8CE9X4"
  },
  {
    "name": "Regina González",
    "birthdate": "27/03/1997",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/460734138.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "right",
    "height": 165,
    "draftJersey": 228,
    "macros": {
      "physical": 81,
      "duels": 78,
      "shooting": 70,
      "defence": 92,
      "passing": 70,
      "skills": 61,
      "average": 79
    },
    "matchYtVideoId": "laA7GmRJkLM",
    "profileYtVideoId": "ZegcLgfvEzY"
  },
  {
    "name": "Jenifer Rojas",
    "birthdate": "16/12/1992",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/75771488.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "left",
    "height": 160,
    "draftJersey": 229,
    "macros": {
      "physical": 81,
      "duels": 75,
      "shooting": 62,
      "defence": 69,
      "passing": 80,
      "skills": 79,
      "average": 74
    },
    "matchYtVideoId": "laA7GmRJkLM",
    "profileYtVideoId": "Y66zpL5lrbs"
  },
  {
    "name": "Karla Hernández",
    "birthdate": "03/07/1995",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/124189720.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 162,
    "draftJersey": 230,
    "macros": {
      "physical": 71,
      "duels": 70,
      "shooting": 59,
      "defence": 74,
      "passing": 84,
      "skills": 70,
      "average": 72
    },
    "matchYtVideoId": "laA7GmRJkLM",
    "profileYtVideoId": "GkQC4ohA79o"
  },
  {
    "name": "Melissa García",
    "birthdate": "27/12/1996",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/698561124.png",
    "country": "Mexico",
    "role": "DL",
    "foot": "right",
    "height": 159,
    "draftJersey": 231,
    "macros": {
      "physical": 83,
      "duels": 79,
      "shooting": 76,
      "defence": 74,
      "passing": 73,
      "skills": 52,
      "average": 74
    },
    "matchYtVideoId": "laA7GmRJkLM",
    "profileYtVideoId": "QDyyu_UOyxM"
  },
  {
    "name": "Britania Herrera",
    "birthdate": "08/03/2001",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/304639277.png",
    "country": "Mexico",
    "role": "DL",
    "foot": "right",
    "height": 164,
    "draftJersey": 232,
    "macros": {
      "physical": 79,
      "duels": 69,
      "shooting": 66,
      "defence": 78,
      "passing": 68,
      "skills": 79,
      "average": 72
    },
    "matchYtVideoId": "laA7GmRJkLM",
    "profileYtVideoId": "B_cSYhb1Pp0"
  },
  {
    "name": "Hireri Velázquez",
    "birthdate": "11/03/1995",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/840819654.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 161,
    "draftJersey": 236,
    "macros": {
      "physical": 82,
      "duels": 84,
      "shooting": 77,
      "defence": 87,
      "passing": 82,
      "skills": 89,
      "average": 83
    },
    "matchYtVideoId": "laA7GmRJkLM",
    "profileYtVideoId": "miMQ4bzaP-g"
  },
  {
    "name": "Arodi Becerra",
    "birthdate": "15/09/2000",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/745320904.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "left",
    "height": 167,
    "draftJersey": 237,
    "macros": {
      "physical": 57,
      "duels": 63,
      "shooting": 70,
      "defence": 77,
      "passing": 87,
      "skills": 51,
      "average": 69
    },
    "matchYtVideoId": "laA7GmRJkLM",
    "profileYtVideoId": "5FwswXAOExg"
  },
  {
    "name": "Danna Dávila",
    "birthdate": "17/03/2004",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/243245776.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 164,
    "draftJersey": 239,
    "macros": {
      "physical": 81,
      "duels": 66,
      "shooting": 62,
      "defence": 70,
      "passing": 76,
      "skills": 61,
      "average": 69
    },
    "matchYtVideoId": "laA7GmRJkLM",
    "profileYtVideoId": "VRDbaCNz2Fs"
  },
  {
    "name": "Abigail Ramirez",
    "birthdate": "08/07/2003",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/460197859.png",
    "country": "Mexico",
    "role": "DL",
    "foot": "right",
    "height": 159,
    "draftJersey": 240,
    "macros": {
      "physical": 85,
      "duels": 70,
      "shooting": 65,
      "defence": 84,
      "passing": 72,
      "skills": 71,
      "average": 73
    },
    "matchYtVideoId": "laA7GmRJkLM",
    "profileYtVideoId": "r_S7KDLp7G0"
  },
  {
    "name": "Ana López",
    "birthdate": "18/06/1994",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/976802513.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "right",
    "height": 163,
    "draftJersey": 242,
    "macros": {
      "physical": 77,
      "duels": 61,
      "shooting": 62,
      "defence": 88,
      "passing": 92,
      "skills": 61,
      "average": 77
    },
    "matchYtVideoId": "laA7GmRJkLM",
    "profileYtVideoId": "Z4aNPOIBcPU"
  },
  {
    "name": "Stephania Salgado",
    "birthdate": "30/01/1989",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/686573306.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "right",
    "height": 171,
    "draftJersey": 243,
    "macros": {
      "physical": 76,
      "duels": 73,
      "shooting": 76,
      "defence": 81,
      "passing": 83,
      "skills": 69,
      "average": 78
    },
    "matchYtVideoId": "laA7GmRJkLM",
    "profileYtVideoId": "uLHrAVu6-3s"
  },
  {
    "name": "Yuriko Castillo",
    "birthdate": "22/07/2004",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/202685917.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 156,
    "draftJersey": 245,
    "macros": {
      "physical": 85,
      "duels": 84,
      "shooting": 84,
      "defence": 79,
      "passing": 89,
      "skills": 62,
      "average": 80
    },
    "matchYtVideoId": "laA7GmRJkLM",
    "profileYtVideoId": "FHMkLySGeuI"
  },
  {
    "name": "Mariana Velázquez",
    "birthdate": "25/01/1992",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/972898341.png",
    "country": "Mexico",
    "role": "DL",
    "foot": "right",
    "height": 165,
    "draftJersey": 252,
    "macros": {
      "physical": 67,
      "duels": 69,
      "shooting": 71,
      "defence": 68,
      "passing": 83,
      "skills": 60,
      "average": 70
    },
    "matchYtVideoId": "TuwUW9m_xWw",
    "profileYtVideoId": "cwhGFmWSg-g"
  },
  {
    "draftJersey": 346,
    "draftJerseyPrefix":  "MED",
    "role": "DF",
    "name": "Andrea Llorente",
    "foot": "right",
    "height": 163,
    "birthdate": "08/08/2005",
    "country": "COL",
    "macros": {
      "physical": 71,
      "duels": 70,
      "shooting": 68,
      "passing": 83,
      "defence": 93,
      "skills": 70,
      "average": 79
    },
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/983145187.png",
    "profileYtVideoId": "YDvoXG58Xl8",
    "matchYtVideoId": "me4aOU5C7Gw"
  },
  {
    "draftJersey": 357,
    "draftJerseyPrefix":  "MED",
    "role": "MC",
    "name": "Daniela Valencia",
    "foot": "right",
    "height": 158,
    "birthdate": "17/02/2000",
    "country": "COL",
    "macros": {
      "physical": 74,
      "duels": 75,
      "shooting": 73,
      "passing": 87,
      "defence": 97,
      "skills": 70,
      "average": 79
    },
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/266415335.png",
    "profileYtVideoId": "RZpZdv_gS1I",
    "matchYtVideoId": "me4aOU5C7Gw"
  },
  {
    "draftJersey": 358,
    "draftJerseyPrefix":  "MED",
    "role": "MC",
    "name": "Luisa Restrepo",
    "foot": "right",
    "height": 155,
    "birthdate": "28/01/2002",
    "country": "COL",
    "macros": {
      "physical": 70,
      "duels": 88,
      "shooting": 77,
      "passing": 76,
      "defence": 93,
      "skills": 97,
      "average": 83
    },
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/964600874.png",
    "profileYtVideoId": "xix8c-NIZU8",
    "matchYtVideoId": "me4aOU5C7Gw"
  },
  {
    "draftJersey": 378,
    "draftJerseyPrefix":  "MED",
    "role": "DL",
    "name": "Valentina Franco",
    "foot": "right",
    "height": 150,
    "birthdate": "02/01/2002",
    "country": "COL",
    "macros": {
      "physical": 69,
      "duels": 88,
      "shooting": 75,
      "passing": 77,
      "defence": 92,
      "skills": 97,
      "average": 82
    },
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/240725214.png",
    "profileYtVideoId": "IqGO3l-DbAU",
    "matchYtVideoId": "me4aOU5C7Gw"
  }
]
